// @flow
export { default } from './TagItem';



// WEBPACK FOOTER //
// ./src/components/tags/TagItem/index.js